import { render, staticRenderFns } from "./reviewDetail.vue?vue&type=template&id=19cb70eb&scoped=true&"
import script from "./reviewDetail.vue?vue&type=script&lang=js&"
export * from "./reviewDetail.vue?vue&type=script&lang=js&"
import style0 from "./reviewDetail.vue?vue&type=style&index=0&id=19cb70eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cb70eb",
  null
  
)

export default component.exports